import jwt_decode from 'jwt-decode'
import isInterimAccessToken from '@/utils/isInterimAccessToken'

const getUserIdFromToken = (accessToken: string) => {
  // Mock the hook only for regression tests
  const isCypressRegression = window.Cypress

  if (isCypressRegression) {
    return undefined
  }

  const interim = isInterimAccessToken(accessToken)
  const decoded = jwt_decode(accessToken) as any

  if (!interim) {
    return decoded['https://babylonhealth.com/user'] as string
  }

  return undefined
}

export default getUserIdFromToken
